module.exports = __webpack_public_path__ + "images/2265e52f93d5f5690fd8f7b96a714192.png";